import { render } from "./Tab3.vue?vue&type=template&id=480be10f&scoped=true&ts=true"
import script from "./Tab3.vue?vue&type=script&lang=ts"
export * from "./Tab3.vue?vue&type=script&lang=ts"

import "./Tab3.vue?vue&type=style&index=0&id=480be10f&scoped=true&lang=css"

import exportComponent from "/Users/michael/Sites/firegui_multilink_app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480be10f"]])

export default __exports__